import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { environment } from '../../environments/environment';
import { getStoredUser } from '../helpers/user-storage.util';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-address-verification-banner',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './address-verification-banner.component.html',
  styleUrl: './address-verification-banner.component.scss',
})
export class AddressVerificationBannerComponent {
  constructor(private authenticationService: AuthenticationService) {}

  // Connect 2.0: the session is an httpOnly cookie, so the readable session hint
  // is the only client-side check (AuthGuard's me() call refreshes the stored
  // user on navigation). The 1.0 setup-lock condition is gone because 2.0's
  // setup lock lets a locked vendor open Manage Account.
  get needsAddressVerification(): boolean {
    if (
      !environment.addressVerificationEnabled ||
      !this.authenticationService.isLoggedIn()
    ) {
      return false;
    }

    const user = getStoredUser();
    return user?.addressVerificationNeeded === true;
  }
}
